import { cn, getNetworkName, SimpleSelectContent } from '@valiant/ui-shared'
import { ChevronDown } from 'lucide-react'
import { Select, SelectItem, SelectTrigger, SelectValue } from '@valiant/ui-shared'

interface Network {
  id: string
  chain: string
}

interface NetworkSelectorProps {
  value: string
  onValueChange: (value: string) => void
  networks: Network[]
}

const BigChevronDownIcon = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'flex items-center justify-center bg-main rounded-md w-8 h-9 text-white',
      className,
    )}
  >
    <ChevronDown className="shrink-0 h-6 w-6 text-white" />
  </div>
)

export const NetworkSelector = ({ value, onValueChange, networks }: NetworkSelectorProps) => {
  const isSingleNetwork = networks.length === 1

  return (
    <div className="relative">
      <label className="text-sm font-medium text-gray-700 mb-2 block absolute top-0 -translate-y-1/2 left-4.5 bg-white px-1 z-10">
        Network:
      </label>

      {isSingleNetwork ? (
        <div className="w-full px-4.5 py-3.5 border border-input rounded-md bg-background text-lg font-semibold text-gray-900">
          {getNetworkName(networks[0].chain)}
        </div>
      ) : (
        <Select value={value} onValueChange={onValueChange}>
          <SelectTrigger
            className="w-full px-4.5 py-2.5 cursor-pointer"
            size="lg"
            OverrideChevron={BigChevronDownIcon}
          >
            <SelectValue placeholder="Select network">
              {value && (
                <span className="text-lg font-semibold text-gray-900">
                  {getNetworkName(networks.find((n) => n.id === value)?.chain ?? '')}
                </span>
              )}
            </SelectValue>
          </SelectTrigger>
          <SimpleSelectContent>
            {networks.map((network, index) => (
              <div key={network.id}>
                <SelectItem value={network.id} className="py-3">
                  <span className="text-lg font-bold text-gray-900">
                    {getNetworkName(network.chain)}
                  </span>
                </SelectItem>
                {index < networks.length - 1 && <div className="border-b border-gray-200 mx-4" />}
              </div>
            ))}
          </SimpleSelectContent>
        </Select>
      )}
    </div>
  )
}
